import Radiusses from '../../tokens/Radiusses';

export interface RadiusesTheme {
  radiuses: {
    S: Radiusses;
    M: Radiusses;
    L: Radiusses;
    XL: Radiusses;
    XXL: Radiusses;
  };
}

export const defaultRadiuses: RadiusesTheme = {
  radiuses: {
    S: Radiusses.S,
    M: Radiusses.M,
    L: Radiusses.L,
    XL: Radiusses.XL,
    XXL: Radiusses.XXL,
  },
};

export const bisRadiuses: RadiusesTheme = {
  radiuses: {
    S: Radiusses.M,
    M: Radiusses.M,
    L: Radiusses.M,
    XL: Radiusses.XL,
    XXL: Radiusses.XXL,
  },
};
